function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { useMemo } from "react";
var isConfiguredPreset = function(transition) {
    return typeof transition === 'object' && !!transition.preset;
};
var getCustomFromPreset = function(transition) {
    var options = {};
    var transitionName = transition;
    if (typeof transition !== 'string') {
        if (!isConfiguredPreset(transition)) {
            return transition;
        }
        var preset = transition.preset, filteredOptions = _objectWithoutProperties(transition, [
            "preset"
        ]);
        transitionName = preset;
        options = filteredOptions;
    }
    switch(transitionName){
        case 'fade':
            return getFadeTransition(options);
        case 'scale':
            return getScaleTransition(options);
        case 'slide-down':
            return getSlideDownTransition(options);
        case 'slide-up':
            return getSlideUpTransition(options);
        case 'slide-left':
            return getSlideLeftTransition(options);
        case 'slide-right':
            return getSlideRightTransition(options);
        default:
            return {
                in: {},
                out: {},
                transitionProperty: ''
            };
    }
};
var mergeAndCombineTransforms = function(a, b) {
    if (!a && !b) {
        return;
    }
    if ((a === null || a === void 0 ? void 0 : a.transform) && (b === null || b === void 0 ? void 0 : b.transform)) {
        return _objectSpread({}, a, b, {
            transform: "".concat(a.transform, " ").concat(b.transform)
        });
    }
    return _objectSpread({}, a, b);
};
var mergeCustomTransitions = function(a, b) {
    if (!a) {
        return b;
    }
    if (!b) {
        return a;
    }
    var combined = a;
    Object.keys(b).forEach(function(key) {
        if (key === 'transitionProperty') {
            combined[key] = combineTransitionProperties(a[key], b[key]);
        } else {
            combined[key] = mergeAndCombineTransforms(a[key], b[key]);
        }
    });
    return combined;
};
var combineTransitionProperties = function(a, b) {
    if (a.length) {
        var aParts = a.split(',');
        var bParts = b.length ? b.split(',') : [];
        var uniqueTransitions = _toConsumableArray(new Set(_toConsumableArray(aParts).concat(_toConsumableArray(bParts))));
        return uniqueTransitions.join(',');
    }
    return b;
};
export var usePresetTransition = function(transitions) {
    return useMemo(function() {
        if (transitions === undefined) {
            return;
        }
        if (!Array.isArray(transitions)) {
            return getCustomFromPreset(transitions);
        }
        return transitions.reduce(function(acc, transition) {
            var t = getCustomFromPreset(transition);
            return mergeCustomTransitions(acc, t);
        }, {
            in: {},
            out: {},
            transitionProperty: ''
        });
    }, [
        transitions
    ]);
};
var getFadeTransition = function() {
    var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        inFade: 1,
        outFade: 0
    };
    var _inFade = _param.inFade, inFade = _inFade === void 0 ? 1 : _inFade, _outFade = _param.outFade, outFade = _outFade === void 0 ? 0 : _outFade, options = _objectWithoutProperties(_param, [
        "inFade",
        "outFade"
    ]);
    return _objectSpread({
        in: {
            opacity: inFade
        },
        out: {
            opacity: outFade
        },
        transitionProperty: 'opacity'
    }, options);
};
export { getFadeTransition };
var getScaleTransition = function(_param) {
    var _outScale = _param.outScale, outScale = _outScale === void 0 ? 0 : _outScale, _inScale = _param.inScale, inScale = _inScale === void 0 ? 1 : _inScale, options = _objectWithoutProperties(_param, [
        "outScale",
        "inScale"
    ]);
    return _objectSpread({
        in: {
            transform: "scale(".concat(inScale, ")")
        },
        out: {
            transform: "scale(".concat(outScale, ")")
        },
        transitionProperty: 'transform'
    }, options);
};
export { getScaleTransition };
var getSlideTransition = function(_param) {
    var _directionMultiplier = _param.directionMultiplier, directionMultiplier = _directionMultiplier === void 0 ? 1 : _directionMultiplier, _axis = _param.axis, axis = _axis === void 0 ? 'X' : _axis, _distance = _param.distance, distance = _distance === void 0 ? '100%' : _distance, options = _objectWithoutProperties(_param, [
        "directionMultiplier",
        "axis",
        "distance"
    ]);
    return _objectSpread({
        in: {
            transform: "translate".concat(axis, "(0)")
        },
        out: {
            transform: "translate".concat(axis, "(calc(").concat(directionMultiplier, " * ").concat(typeof distance === 'number' ? "".concat(distance, "px") : distance, "))")
        },
        transitionProperty: 'transform'
    }, options);
};
export { getSlideTransition };
export var getSlideDownTransition = function(options) {
    return getSlideTransition(_objectSpread({}, options, {
        axis: 'Y',
        directionMultiplier: -1
    }));
};
export var getSlideUpTransition = function(options) {
    return getSlideTransition(_objectSpread({}, options, {
        axis: 'Y',
        directionMultiplier: 1
    }));
};
export var getSlideLeftTransition = function(options) {
    return getSlideTransition(_objectSpread({}, options, {
        axis: 'X',
        directionMultiplier: 1
    }));
};
export var getSlideRightTransition = function(options) {
    return getSlideTransition(_objectSpread({}, options, {
        axis: 'X',
        directionMultiplier: -1
    }));
};
